// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2W9sl","right":"Footer_right__3FjEg","buttons":"Footer_buttons__3AkY2"};